"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isRootOption(item) {
    return item && item.isHierarchyRoot;
}
exports.default = isRootOption;
